// frontend/src/components/AdminOracleState3D.jsx
import React, { useRef, useEffect, useState } from "react";
import { Canvas, useFrame } from "@react-three/fiber";
import { OrbitControls } from "@react-three/drei";

const sendEntropyUpdate = async (entropy_ui, entropy_dyn) => {
  try {
    console.log(
      `%c[cube_dynamics] → UI:${entropy_ui.toFixed(3)} | DYN:${entropy_dyn.toFixed(3)}`,
      "color:#00e0ff;font-weight:bold"
    );
    await Promise.all([
      fetch(`/api/geometry/cube_dynamics/entropy`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ entropy_ui }),
      }),
      fetch(`/api/geometry/cube_dynamics/dyn_entropy`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ entropy_dyn }),
      }),
    ]);
  } catch (err) {
    console.error("[cube_dynamics][send] erreur:", err);
  }
};

function RotatingCube({ state }) {
  const meshRef = useRef();
  const [rotationSum, setRotationSum] = useState(0);
  const frameCount = useRef(0);
  const lastFrameTime = useRef(Date.now());

  useFrame(() => {
    if (!meshRef.current) return;
    const now = Date.now();
    if (now - lastFrameTime.current < 16) return;
    lastFrameTime.current = now;

    const { rotationSpeed, color, scale } = state;
    meshRef.current.rotation.x += rotationSpeed * 0.01;
    meshRef.current.rotation.y += rotationSpeed * 0.01;
    meshRef.current.scale.set(scale, scale, scale);

    const currentRotation =
      Math.abs(meshRef.current.rotation.x) + Math.abs(meshRef.current.rotation.y);
    setRotationSum((prev) => prev + currentRotation);

    frameCount.current++;
    if (frameCount.current >= 60) {
      frameCount.current = 0;
      const entropyUI = parseFloat((scale * 10 + rotationSpeed * 5).toFixed(4));
      const entropyDyn = parseFloat((rotationSum % 50).toFixed(4));
      requestAnimationFrame(() => sendEntropyUpdate(entropyUI, entropyDyn));
      setRotationSum(0);
    }
  });

  return (
    <mesh ref={meshRef}>
      <boxGeometry args={[1, 1, 1]} />
      <meshStandardMaterial color={state.color} />
    </mesh>
  );
}

export default function AdminOracleState3D({ state }) {
  const [contextLost, setContextLost] = useState(false);

  const handleContextLost = (event) => {
    event.preventDefault();
    console.warn("[WebGL] Context lost, pause rendering");
    setContextLost(true);
  };

  const handleContextRestored = () => {
    console.log("[WebGL] Context restored");
    setContextLost(false);
  };

  if (contextLost) {
    return (
      <div
        style={{
          width: "100%",
          height: "400px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "#1a1a1a",
          color: "#ff6600",
          borderRadius: "8px",
        }}
      >
        ⚠️ WebGL Context Lost - Rechargez la page
      </div>
    );
  }

  return (
    <div style={{ width: "100%", height: "400px" }}>
      <Canvas
        camera={{ position: [3, 3, 3], fov: 60 }}
        // onContextLost={handleContextLost}
        // onContextRestored={handleContextRestored}
        gl={{
          antialias: true,
          powerPreference: "low-power",
          failIfMajorPerformanceCaveat: false,
          preserveDrawingBuffer: true, // ✅ empêche perte de buffer
        }}
      >
        <ambientLight intensity={0.4} />
        <directionalLight position={[5, 5, 5]} intensity={1} />
        <RotatingCube state={state} />
        <OrbitControls enableDamping={true} />
      </Canvas>
    </div>
  );
}
